// import { Grid } from "@mui/material";
// import React, { useEffect } from "react";
// import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
// import { IRows } from "../../../Components/Filter/WSFilterComponent";
// import { useNavigate } from "react-router-dom";
// import { updateMainHeader } from "../../../commonFunctions/CommonFunctions";
// import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";

// export const SupplierList: React.FC = () => {
//   const navigate = useNavigate();

//   // Header
//   useEffect(() => {
//     updateMainHeader("Inventory");
//   }, []);

//   // Breadcrumbs
//   breadCrumbsStore.updateBreadCrumbs([
//     { "Supplier Management": "/supplier/list" },
//   ]);

//   const source = {
//     url: "Vyapar/Product/search",
//     page: 1,
//     pageSize: 10,
//     filter: [],
//     sort: []
//   };

 
//   const columns: IColumns[] = [
//     { header: "Unit ID", fieldName: "categoryid" },
//     { header: "Supplier Name", fieldName: "suppliername" },
//     { header: "Contact Person", fieldName: "contactperson" },
//      { header: "Phone", fieldName: "phone" },
//     { header: "Email", fieldName: "email" },
//     { header: "Status", fieldName: "status" },
   
//   ];

//   // Filters (UI only)
//   const filterRows: IRows[] = [
//     {
//       label: "Item Name",
//       fieldName: "itemname",
//       type: "text",
//       operator: "like",
//       rowDivision: 6,
//     },
//     {
//       label: "Category",
//       fieldName: "category",
//       type: "text",
//       operator: "like",
//       rowDivision: 6,
//     },
//     {
//       label: "Supplier Name",
//       fieldName: "suppliername",
//       type: "text",
//       operator: "like",
//       rowDivision: 6,
//     },
//     {
//       label: "Created Date",
//       fieldName: "createdAt",
//       type: "date",
//       operator: "gte",
//       rowDivision: 6,
//     },
//   ];

//   const handleClick = () => {
//     navigate("/supplier");
//   };

//   return (
//     <Grid p={3}>
//       <Grid container spacing={2}>
//         <Grid item xs={12}>
//           <WSDataGrid
//             id="itemMasterGrid"
//             title="Customer Management"
//             headerType="modern"
//             columns={columns}
//             source={source}
//             filterFields={filterRows}
//             rowsPerPageCount={10}
//             searchBox={{ fieldName: "itemname" }}
//             addButton={{ label: "Add New Item", color: "secondary" }}
//             onAddButtonClick={handleClick}
//             multiSelect={true}
//             gridHeaderSx={{
//               backgroundColor: "whitesmoke",
//               border: "1px solid whitesmoke",
//             }}
//           />
//         </Grid>
//       </Grid>
//     </Grid>
//   );
// };




import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import ConfirmationPopup from "../../../Components/Confirmation/Confirmation";
import { useDispatch } from "react-redux";
import { resetDataComponent } from "../../../StateManagement/actions";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { useNavigate } from "react-router-dom";
import { updateMainHeader } from "../../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
import Inventory2Icon from '@mui/icons-material/Inventory2';
import { labelStore } from "../../../FrontEnd/UpdateChange/LableStore";


export const SupplierList: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showMessage } = useSnackbar();
  
  const [selectedId, setSelectedId] = useState<string | number>(0);
  const [isPopupOpen, setPopupOpen] = useState(false);

  // Header
  useEffect(() => {
  updateMainHeader("Inventory");
  labelStore.updateIcon(<Inventory2Icon sx={{ fontSize: 32 }} />);
}, []);

  // Breadcrumbs
  breadCrumbsStore.updateBreadCrumbs([
    { "Supplier Management": "/supplier/list" },
  ]);

  const source = {
    url: "suppliers/list",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: [],
    type: 'GET' as const 
  };

  const columns: IColumns[] = [
    // { header: "Supplier ID", fieldName: "SupplierId" },
    { header: "Supplier Name", fieldName: "SupplierName" },
    { header: "Contact Person", fieldName: "ContactPerson" },
    { header: "Phone", fieldName: "Phone" },
    { header: "Email", fieldName: "Email" },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: ["Edit", "Delete"],
      actionCallback: (action: string, row: any) => {
        if (action === "Edit") {
          navigate(`/supplier/${row.SupplierId}`);
        } else if (action === "Delete") {
          setSelectedId(row.SupplierId);
          setPopupOpen(true);
        }
      },
    },
  ];

  // Filters (UI only)
  

  const handleClick = () => {
    navigate("/supplier");
  };

  return (
    <Grid p={3}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <WSDataGrid
            id="supplierGrid"
            title="Supplier Management"
            headerType="modern"
            columns={columns}
            source={source}
            exportCsv
            rowsPerPageCount={10}
            searchBox={{ fieldName: "SupplierName" }}
            addButton={{ label: "Add New Supplier", color: "secondary" }}
            onAddButtonClick={handleClick}
            multiSelect={true}
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke",
            }}
          />
        </Grid>
        
        {}
        <ConfirmationPopup
          type="DELETE"
          apiUrl="suppliers"
          id={selectedId}
          confirmMessage="Are you sure you want to delete this supplier?"
          open={isPopupOpen}
          onClose={() => setPopupOpen(false)}
          onConfirm={(data: any) => {
            dispatch(resetDataComponent("supplierGrid"));
            if (data.success === true) {
              showMessage(data?.message, "success");
            } else {
              showMessage(data?.detail, "error");
            }
          }}
        />
      </Grid>
    </Grid>
  );
};
